import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 25 2019
 *
 * @///<reference path="packages/common-dp/src/core/transfer/common/model/TransferProcessorLog.ts"/>
 *
 * @author Tomáš Leity
 * @author Vojtěch Smolař
 */
import { DomainObject } from '@logio/common-be-fe';
/**
 * Details about processing single processor.
 */

export var DPTransferProcessorLog =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DPTransferProcessorLog, _DomainObject);

  /**
   * @param name the name of processor
   * @param started the start of running the processor
   * @param finished the end date of processing (regardless of success or error)
   * @param localFile File on local file system that should be used for import instead of file from IDB.
   * @param status the status of running the processor
   */
  function DPTransferProcessorLog(name, started, finished, localFile, status) {
    var _this;

    _classCallCheck(this, DPTransferProcessorLog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DPTransferProcessorLog).call(this));
    _this.name = name;
    _this.started = started;
    _this.finished = finished;
    _this.localFile = localFile;
    _this.status = status;
    return _this;
  }

  return DPTransferProcessorLog;
}(DomainObject);